"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactToolbar = require("@cdk-uip/react-toolbar");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Used to divide the CDK global header into sections.
 */


var GlobalHeaderSection = function GlobalHeaderSection(props) {
  return _react2.default.createElement(_reactToolbar.ToolbarSection, props);
};

exports.default = GlobalHeaderSection;